import { parse, isValid, format } from "date-fns";
import moment from "moment";
import { YYYYMMDD } from "./constants/appConstants";

export const DATE_INPUT_FORMATS = [
  "dd-MMM-yyyy",
  "d-MMM-yyyy",
  "dd-MM-yyyy",
  "d-MM-yyyy"
];

/**
 * Normalize user input for reliable comparison
 */
const normalize = (v) => v?.trim().replace(/\s+/g, "").toLowerCase();

/**
 * Strict date validation:
 * parse -> format back -> compare with input
 */
export const isValidTypedDate = (value) => {
  if (!value) return false;

  const input = normalize(value);

  return DATE_INPUT_FORMATS.some((fmt) => {
    const parsed = parse(input, fmt, new Date());

    if (!isValid(parsed)) return false;

    return normalize(format(parsed, fmt)) === input;
  });
};

/**
 * Parse only if STRICTLY valid
 */
export const parseTypedDate = (value) => {
  if (!value) return null;

  const input = normalize(value);

  for (const fmt of DATE_INPUT_FORMATS) {
    const parsed = parse(input, fmt, new Date());

    if (isValid(parsed) && normalize(format(parsed, fmt)) === input) {
      return parsed;
    }
  }

  return null;
};

/**
 * Handles calendar date selection
 */
export const handleDateChange = (date, onChange) => {
  if (date instanceof Date && !isNaN(date)) {
    onChange(date);
  } else {
    onChange(null);
  }
};

/**
 * Handles manual typing in input box
 */
export const handleRawDateChange = ({
  event,
  onChange,
  minDate,
  maxDate,
  validateRange = false
}) => {
  const input = event.target.value;

  if (!isValidTypedDate(input)) {
    onChange(null);
    return;
  }

  const parsedDate = parseTypedDate(input);

  if (
    validateRange &&
    ((minDate && parsedDate < minDate) || (maxDate && parsedDate > maxDate))
  ) {
    onChange(null);
    return;
  }

  onChange(parsedDate);
};

export const formatMomentDate = (date) =>
  date ? moment(date).format(YYYYMMDD) : moment().format(YYYYMMDD);
